// extracted by mini-css-extract-plugin
module.exports = {"origin":"Fixed_origin__3wm2w","faker":"Fixed_faker__1ieOB","top":"Fixed_top__11DtS","bottom":"Fixed_bottom__2Et5x"};